import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

interface WalkdownState {
  currentWalkdownNumbers: string[];
  currentWalkdownIds: string[];
}

const initialState: WalkdownState = {
  currentWalkdownNumbers: [],
  currentWalkdownIds: [],
};

export const walkdownSlice = createSlice({
  name: 'walkdown',
  initialState,
  reducers: {
    setCurrentWalkdownInfo(state, action: PayloadAction<{ walkdownIds: string[]; walkdownNumbers: string[] }>) {
      state.currentWalkdownIds = action.payload.walkdownIds;
      state.currentWalkdownNumbers = action.payload.walkdownNumbers;
    },
    clearCurrentWalkdownInfo(state) {
      state.currentWalkdownIds = [];
      state.currentWalkdownNumbers = [];
    },
  },
});

export const { setCurrentWalkdownInfo, clearCurrentWalkdownInfo } = walkdownSlice.actions;
export const walkdownReducer = walkdownSlice.reducer;
